import useCurrencies from './useCurrencies'

const currencyEmoji = {
  AED: '🇦🇪',
  ARS: '🇦🇷',
  AUD: '🇦🇺',
  BDT: '🇧🇩',
  BGN: '🇧🇬',
  BHD: '🇧🇭',
  BOB: '🇧🇴',
  BRL: '🇧🇷',
  BTC: '₿',
  CAD: '🇨🇦',
  CHF: '🇨🇭',
  CLP: '🇨🇱',
  CNY: '🇨🇳',
  COP: '🇨🇴',
  CZK: '🇨🇿',
  DKK: '🇩🇰',
  DOP: '🇩🇴',
  DZD: '🇩🇿',
  EGP: '🇪🇬',
  EUR: '🇪🇺',
  FJD: '🇫🇯',
  GBP: '🇬🇧',
  GHS: '🇬🇭',
  GTQ: '🇬🇹',
  HKD: '🇭🇰',
  IDR: '🇮🇩',
  ILS: '🇮🇱',
  INR: '🇮🇳',
  IQD: '🇮🇶',
  IRR: '🇮🇷',
  ISK: '🇮🇸',
  JOD: '🇯🇴',
  JPY: '🇯🇵',
  KES: '🇰🇪',
  KHR: '🇰🇭',
  KRW: '🇰🇷',
  KWD: '🇰🇼',
  LAK: '🇱🇦',
  LBP: '🇱🇧',
  LKR: '🇱🇰',
  MAD: '🇲🇦',
  MMK: '🇲🇲',
  MXN: '🇲🇽',
  MYR: '🇲🇾',
  NGN: '🇳🇬',
  NOK: '🇳🇴',
  NPR: '🇳🇵',
  NZD: '🇳🇿',
  OMR: '🇴🇲',
  PEN: '🇵🇪',
  PHP: '🇵🇭',
  PKR: '🇵🇰',
  PLN: '🇵🇱',
  PYG: '🇵🇾',
  QAR: '🇶🇦',
  RON: '🇷🇴',
  RUB: '🇷🇺',
  SAR: '🇸🇦',
  SEK: '🇸🇪',
  SGD: '🇸🇬',
  SYP: '🇸🇾',
  THB: '🇹🇭',
  TRY: '🇹🇷',
  TWD: '🇹🇼',
  UAH: '🇺🇦',
  USD: '🇺🇸',
  UYU: '🇺🇾',
  UZS: '🇺🇿',
  VND: '🇻🇳',
  XAG: 'Ag',
  YER: '🇾🇪',
  ZAR: '🇿🇦'
}

function useSupportedCurrencies(){
  const currencies = useCurrencies()
  const codes = currencies ? currencies.map(currency => currency.cc).sort() : []

  return {
    count: codes.length,
    list: codes.join(', '),
    flaggedList: codes.map(code => `${currencyEmoji[code] || '¤'} ${code}`).join(', ')
  }
}

export default useSupportedCurrencies;
